import { slickPrevArrow, slickNextArrow } from '../functions'

export const recommendedSupplies = {
  slickOptions: {
    rows: 0,
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    rtl: window.Trillion.rtl,
    prevArrow: slickPrevArrow(),
    nextArrow: slickNextArrow(),
    responsive: [
      { breakpoint: 1330, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      { breakpoint: 920, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 600, settings: { dots: true, arrows: false, slidesToShow: 1, slidesToScroll: 1 } },
    ]
  }
}

export const relatedProducts = {
  slickOptions: {
    rows: 0,
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    rtl: window.Trillion.rtl,
    prevArrow: slickPrevArrow(),
    nextArrow: slickNextArrow(),
    responsive: [
      { breakpoint: 1332, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 668, settings: { dots: true, arrows: false, slidesToShow: 1, slidesToScroll: 1 } },
    ]
  }
}
